import api from './api';
import { API_ENDPOINTS } from '../constants';

export interface Shift {
  id: string;
  name: string;
  type: 'general' | 'day' | 'night' | 'first' | 'second' | 'time_based';
  start_time?: string;
  end_time?: string;
  description?: string;
  cluster_id?: string;
  is_active: boolean;
  created_by: string;
  updated_by?: string;
  created_at: string;
  updated_at: string;
  cluster?: {
    id: string;
    name: string;
    code: string;
  };
}

export interface ShiftFilters {
  search?: string;
  type?: string;
  cluster_id?: string;
  is_active?: boolean;
  page?: number;
  limit?: number;
  sort?: string;
  order?: 'asc' | 'desc';
}

const shiftService = {
  /**
   * Get shifts with filters
   */
  getShifts: async (filters: ShiftFilters = {}): Promise<{
    shifts: Shift[];
    pagination: {
      page: number;
      limit: number;
      total: number;
      pages: number;
    };
  }> => {
    const response = await api.get<{
      success: boolean;
      message: string;
      data: {
        shifts: Shift[];
        pagination: {
          page: number;
          limit: number;
          total: number;
          pages: number;
        };
      };
    }>(API_ENDPOINTS.SHIFTS.LIST, {
      params: filters,
    });
    return response.data.data;
  },

  /**
   * Get shift by ID
   */
  getShiftById: async (shiftId: string): Promise<Shift> => {
    const response = await api.get<{
      success: boolean;
      message: string;
      data: Shift;
    }>(API_ENDPOINTS.SHIFTS.GET_BY_ID(shiftId));
    return response.data.data;
  },

  /**
   * Create shift
   */
  createShift: async (shiftData: Partial<Shift>): Promise<Shift> => {
    const response = await api.post<{
      success: boolean;
      message: string;
      data: Shift;
    }>(API_ENDPOINTS.SHIFTS.CREATE, shiftData);
    return response.data.data;
  },

  /**
   * Update shift
   */
  updateShift: async (shiftId: string, shiftData: Partial<Shift>): Promise<Shift> => {
    const response = await api.put<{
      success: boolean;
      message: string;
      data: Shift;
    }>(API_ENDPOINTS.SHIFTS.UPDATE(shiftId), shiftData);
    return response.data.data;
  },

  /**
   * Delete shift
   */
  deleteShift: async (shiftId: string): Promise<void> => {
    await api.delete(API_ENDPOINTS.SHIFTS.DELETE(shiftId));
  },
};

export default shiftService;

